import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
// import "../ExamList/exam-list.scss"
// import "./analysis-filter.scss"
import MultiDropdown from "../../../components/dropDown/MultiDropdown";
import {setGlobalAnalysisTFilter} from "../../../store/slices/examSlice";


export const AnalysisTFilter = ({Desktop,TabletAndBelow,handleSearch,handleReset,
                               handleClose,isAdmin}) => {
    const dispatch = useDispatch();
    const filters = JSON.parse(localStorage.getItem(`analysisTFilters`) || "{}");
    const [typeFilter, setTypeFilter] = useState(filters.typeFilter || []);
    const [subjectFilter, setSubjectFilter] = useState(filters.subjectFilter || []);
    const [yearFilter, setYearFilter] = useState(filters.yearFilter || []);
    const [testFilter, setTestFilter] = useState(filters.testFilter || "");
    const { analysisTdata } = useSelector((state) => state.exam);

    const subjects = useRef([]);
    const years = useRef([]);

    const handleTypeChange = (val) => {
        setTypeFilter(val);
        handleFilterChange(val,1);
        // console.log("i am called 3");
    };
    const handleSubjectChange = (val) => {
        setSubjectFilter(() => { return val});
        handleFilterChange(val,2);
    }
    const handleYearChange = (val) => {
        setYearFilter(() => { return val});
        handleFilterChange(val,3);
    }

    const handleFilterChange = (val,mode) => {
        const payload = JSON.parse(localStorage.getItem(`analysisTFilters`) || "{}");

        if(mode === 1)payload.typeFilter = val;
        else if(mode === 2)payload.subjectFilter = val;
        else if(mode === 3)payload.yearFilter = val;
        else if(mode === 4)payload.testFilter = val;
        dispatch(setGlobalAnalysisTFilter(payload));

    }
    const handleTestChange = (val) => {
        setTestFilter(val);
        handleFilterChange(val,4);
    }

    useEffect(() => {
        subjects.current = analysisTdata.subjects;
        years.current = analysisTdata.years;
    }, []);
    return (
    <>
        <Desktop>
            <div className="flexy question-type-div">
                <div className="col-md-11 flexy">
                    {" "}
                    <div className="col-md-4">
                        <h6>Exam Type:</h6>
                        <MultiDropdown type={1} selectedValues={typeFilter} handleChange={handleTypeChange} options={analysisTdata.types}></MultiDropdown>
                    </div>
                    <div className="col-md-4">
                        <h6>Exam Subject:</h6>
                        {/*<input placeholder="Chemistry, Physics" name="subject" onChange={handleSetFilter} />*/}
                        <MultiDropdown type={2} selectedValues={subjectFilter} handleChange={handleSubjectChange} options={analysisTdata.subjects}></MultiDropdown>
                    </div>
                    <div className="col-md-4">
                        <h6>Exam Year:</h6>
                        <MultiDropdown type={3} selectedValues={yearFilter} handleChange={handleYearChange} options={analysisTdata.years}></MultiDropdown>
                    </div>
                    {/*<div className="col-md-3">*/}
                    {/*    <h6>Test Title:</h6>*/}
                    {/*    <div  className={`c-multi-select-dropdown__option search`}>*/}
                    {/*        <input value={testFilter}  type="text"  onChange={(e) => {*/}
                    {/*            handleTestChange(e.target.value);*/}
                    {/*        }}  placeholder="Search..."*/}
                    {/*               className="c-multi-select-dropdown__option-checkbox_title"></input>*/}
                    {/*        /!*<img onClick={handleClear}  src={Close} alt="Scholar" />*!/*/}
                    {/*    </div>      */}
                    {/*</div>*/}
                </div>
                <div className="col-md-1 ">
                    <button className="search" onClick={handleSearch}>Search</button>
                </div>
            </div>

        </Desktop>
        <TabletAndBelow>
            <div className="flexy question-type-div">
                <div className="col-md-11 flexy">
                    {" "}
                    <div className="col-md-4">
                        <h6>Exam Type:</h6>
                        <MultiDropdown type={1} selectedValues={typeFilter} handleChange={handleTypeChange} options={analysisTdata.types}></MultiDropdown>
                    </div>
                    <div className="col-md-4">
                        <h6>Exam Subject:</h6>
                        {/*<input placeholder="Chemistry, Physics" name="subject" onChange={handleSetFilter} />*/}
                        <MultiDropdown type={2} selectedValues={subjectFilter} handleChange={handleSubjectChange} options={analysisTdata.subjects}></MultiDropdown>
                    </div>
                    <div className="col-md-4">
                        <h6>Exam Year:</h6>
                        <MultiDropdown type={3} selectedValues={yearFilter} handleChange={handleYearChange} options={analysisTdata.years}></MultiDropdown>
                    </div>
                    {/*<div className="col-md-3">*/}
                    {/*    <h6>Test Title:</h6>*/}
                    {/*    <div  className={`c-multi-select-dropdown__option search`}>*/}
                    {/*        <input value={testFilter}  type="text"  onChange={(e) => {*/}
                    {/*            handleTestChange(e.target.value);*/}
                    {/*        }}  placeholder="Search..."*/}
                    {/*               className="c-multi-select-dropdown__option-checkbox_title"></input>*/}
                    {/*        /!*<img onClick={handleClear}  src={Close} alt="Scholar" />*!/*/}
                    {/*    </div>               */}
                    {/*</div>*/}
                </div>
                <div className="col-md-1 ">
                    <button className="search" onClick={handleSearch}>Search</button>
                    <button className="reset" onClick={handleReset}>Reset</button>

                </div>
            </div>
        </TabletAndBelow>

    </>
  );
};
